import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { FiltersM } from '../../../components/models';
import { ServiciosRiegosService } from '../../../services/riesgo-liquidez/servicios-riegos.service';
import { CookieService } from 'ngx-cookie-service';
import { companiesRiesgoLiquidez } from '../../../shared/catalogos';
import { CommonVariables } from '../../funciones/funcionesGenerales';
import { Header } from '../../../components/contenedor-elementos/interfaces/header.interface';
import { TranslateService } from '@ngx-translate/core';
import { TableroService } from './../../../shared/GenerateTabla/services/tablero.service';
import { TemplateLoaderService } from './../../../shared/GenerateTabla/plantillas/template-loader.service';
import { table } from './../../../shared/GenerateTabla/plantillas/models.model';
import { Aligment, ExcelService, FormatText, TypeRow } from '../../../services/excel/excel.service';
import { messages } from '../../funciones/mensajes';
import { consultaInformatioService } from '../getOperaciones/calculos.service';
import { firstValueFrom } from 'rxjs';
import { FormaterNumberPipe } from '../../../services/pipes/formater-number.pipe';
import moment from 'moment';

@Component({
  selector: 'app-gap-airac',
  templateUrl: './gap-airac.component.html',
  styleUrl: './gap-airac.component.css',
  providers: [FormaterNumberPipe]
})  

export class GapAiracComponent{
  /**
   * Variables de intitución y plantillas
   */
  idInst;
  idAdmin;
  idPlantilla = 7;
  /**
   * Variables de filtros
   */
  Filters = FiltersM;
  /**
   * Modales 
   */ 
  modal = false;

  bandasValues = [];
  totalPorcen = '0';
  filaEdit;

  bandas = [];
  total = 0;
  edit = true;
  // Periodos
  periodos = [];
  private numEvaluaciones = 1;
  private periodosSeleccionados = 0;

  cadenaEvaluacion = [];
  /** Configuración titulo */
  header: Header = {
    title: ''
  }

  tablaConfig: table;
  verTabla = false;

  constructor(
    readonly dataService: DataService,
    private service: ServiciosRiegosService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private tableroService: TableroService,
    private readonly templateLoader: TemplateLoaderService,
    private readonly calculos: consultaInformatioService,
    private formaterPipe: FormaterNumberPipe,

    private readonly excelService: ExcelService,
  ){
    this.idInst = this.cookieService.get('idInstitucion');
    this.idAdmin = companiesRiesgoLiquidez.find(c => c.id === this.idInst)?.idAdmin ?? '';
    var instAT = companiesRiesgoLiquidez.find(c => c.id === this.idInst);
    this.idPlantilla = instAT.idPlantilla;
    this.getEvaluaciones()
  }

  /**
   * Consultas
   */
  private async getEvaluaciones(){
    const data = await this.service.getEvaluaciones(this.idPlantilla);
    const info = CommonVariables.obtenerPeriodos([].concat(data.evaluaciones), this.numEvaluaciones);

    // this.header.title = await this.translate.instant('liquidez.gap.tituloTabla');
    this.header.title = 'GAP DE DURACIÓN';
    this.periodos = info.periodos;
    this.getCadenaEvaluacion();
  }
  private async getCadenaEvaluacion(){    
    this.cadenaEvaluacion = this.periodos.flatMap(y => {
      return y.series
      .filter(m => m.check)
      .map(m => {
        return {
          text: m.periodo,
          id: m.id
        }
      })
    });
    this.header.subtitles = this.cadenaEvaluacion;
    this.header = {...this.header};
    await this.postInformationRiesgos();
    this.getData();
  }

  async postInformationRiesgos(){
    if(this.idInst == 2007){
      await this.calculos.revisionCalculo(this.cadenaEvaluacion[0].id, this.idAdmin, this.cadenaEvaluacion[0].text);
    }
  }

  async getData(){
    const configuracion = this.templateLoader.obtenerConfiguracionGap(this.idAdmin);
    this.bandas = configuracion.columnas.slice(1, configuracion.columnas.length-1);
    if(configuracion.filas){
      configuracion.id = this.idAdmin;
      const  tabla = await this.tableroService.getTabla(
        configuracion,
        this.cadenaEvaluacion,
        this.idPlantilla
      );
      this.tablaConfig = tabla;
      this.verTabla = true;
    }else{
      messages.infoMessageGraph(configuracion);
    }
  }

  showAndHide(fila){
    const filas = this.tablaConfig.filas;
    const filter = filas.filter(f => fila.sumar.includes(f.id));
    
    filter.forEach(f =>{
      f.visible = !f.visible;
    });
    
    fila.expandido = !fila.expandido;
  }

  /**
   * Modales
   */

  openModal(fila){
    this.filaEdit = fila;
    this.bandasValues = [...fila.bandasValue];
    this.modal = true;
  }
  public closeModal(){
    this.modal = false;
  }

  public cancelPorcentajes(){
    var i = 0;
    for(const val of this.filaEdit.bandas){
      if(val !== 0 && val !== null){
        this.bandasValues[i] = val;
      }
      i++;
    }
    this.obtenerTotalPorcentajes();
  }
  public actualizarBanda(indice: number, valor: number | null){
    this.bandasValues[indice] = valor ?? 0;
    this.obtenerTotalPorcentajes();
  }

  public obtenerTotalPorcentajes(){
    var aux = [], i=0;
    for(const val of this.bandasValues){
      if(val !== null){
        const valorN = Number(document.getElementById('valor'+i)["value"].replace(/,/g, ''));
        aux.push(valorN);
      }else{
        aux.push(null);
      }
      i++;
    }
    let suma = 0;
    for(const val of aux){
      suma += val;
    }
    this.totalPorcen = this.formaterPipe.transform(suma,0,',','.');
  }

  public seleccionarCero(event: FocusEvent){
    const input = event.target as HTMLInputElement;

    // if (input.value === '0') {
      input.select();
    // }
  }

  public async guardarVariables(){
    let aux = [], i = 0;
    for(const val of this.bandasValues){
      if(val !== null){
        const valorN = Number(document.getElementById('valor'+i)["value"].replace(/,/g, ''))??0;
        aux.push(valorN);
      }else{
        aux.push(null);
      }
      i++;
    }
    this.posteditableRiesgo(aux, this.filaEdit.valorComparar, this.filaEdit.ingresoManual);
  }
  private async posteditableRiesgo(datos, name, manual){
      const peri = moment(this.cadenaEvaluacion[0].text, 'MMM YY');
      try{
        this.bandasValues = [];
        const d = {
          idInstitucion: this.idAdmin,
          anio: peri.year(),
          mes: peri.month()+1,
          nombre: name
        }
        var bandas = [];
        for(var i = 0; i < this.bandas.length; i++){
          this.bandasValues.push(!manual ? datos[i]/100 : datos[i]);
          bandas.push({
            label: this.bandas[i],
            valor: !manual ? datos[i]/100 : datos[i]??0,
            order: i+1
          })
        }
        await firstValueFrom(this.service.postVariblesGapRiesgos(d,bandas))
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));

        const configuracion = this.templateLoader.obtenerConfiguracionGap(this.idAdmin);
        configuracion.id = this.idAdmin;
        const  tabla = await this.tableroService.getTabla(
          configuracion,
          this.cadenaEvaluacion,
          this.idPlantilla
        );
        this.tablaConfig = tabla;
        this.verTabla = true;
        this.closeModal();
        this.filaEdit = undefined;
      }catch(e){
        messages.errorMessageGraph(e);
        this.closeModal();
      }
    }

  /**
   * Metodos de los filtros
   */
  //Cambio de periodo
  cambioPeriodo(per){
    for(const an of this.periodos){
      for(const mes of an.series){
        if(mes.periodo === per.periodo){
          mes.check = true;
        }else{
          mes.check = false;
        }
      }
    }
    this.periodos = [...this.periodos];
    this.getCadenaEvaluacion();
  }

  obtenerTotal(){

  }

  exportExcel(){
    messages.messageSaving(this.translate.instant('swal.generando'), this.translate.instant('swal.espere'))
    var titulos = [], alineacion = [], formato = [], data = [], tipo = [];
    var tituloHoja = '', nombreArch = '';

      alineacion = [
        Aligment.LEFT,
        ...this.tablaConfig.filas[0].bandas.map(f => {return Aligment.RIGHT}),
        Aligment.RIGHT,
      ];
      formato = [
        FormatText.TEXT,
        ...this.tablaConfig.filas[0].bandas.map(f => {return FormatText.NUMBERDEC}),
        FormatText.NUMBERDEC,
      ];
      this.tablaConfig.columnas.forEach(h =>{
        titulos.push(h)
      });
      this.tablaConfig.filas.forEach( f => { 
        const aux = [];
        const auxT = [];
        
        auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
        aux.push(f.descripcion);

        if(f.bandasValue){
          f.bandasValue.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push(v ?? '');
          });
        }else {
          f.bandas.forEach(v => {
            auxT.push(f.type === 'subtotal' || f.type === 'titulo' || f.suma?TypeRow.TOTAL:TypeRow.NORMAL);
            aux.push('');
          });
        }
        
        aux.push(f.total??'');
        auxT.push(TypeRow.TOTAL);
        
        tipo.push(auxT);
        data.push(aux);
      });
    tituloHoja = 'GAP DE DURACIÓN';
    nombreArch = 'gap';

    this.excelService.generateExcel(tituloHoja, titulos, data, nombreArch, alineacion, formato, tipo);
    messages.succesMessageGraph(this.translate.instant('swal.descargaExi'));
  }
}
